import React from 'react';

const SECURITY_PILLARS = [
  {
    icon: '🔐',
    title: 'End-to-End Encryption',
    desc: 'All communications, credentials, and configuration states are encrypted using industry-standard protocols both in transit (TLS 1.3) and at rest (AES-256).',
  },
  {
    icon: '🗝️',
    title: 'Secure Credential Vaulting',
    desc: 'Candor integrates directly with enterprise credential managers, VS Code SecretStorage, and local vaults with ENC_ token encryption. Passwords and keys are never stored in plaintext.',
  },
  {
    icon: '🛡️',
    title: 'Continuous Vulnerability Scanning',
    desc: 'All workflows, generated scripts, and execution engines are constantly monitored and scanned to prevent SQL injections, cross-site scriptings, and security vulnerabilities.',
  },
  {
    icon: '📋',
    title: 'Comprehensive Audit Logs',
    desc: 'Every AI transformation, data ingest trigger, and system configuration change is captured in immutable audit logs for complete enterprise traceability.',
  },
  {
    icon: '🔑',
    title: 'Enterprise SSO & PKCE OAuth',
    desc: 'Zero-trust Single Sign-On supporting Google, GitHub, Microsoft, Yahoo, GitLab, and LinkedIn using Proof Key for Code Exchange (PKCE) and silent JWT token rotation.',
  },
  {
    icon: '⚡',
    title: 'Air-Gapped & Local-Only Execution',
    desc: 'Run completely air-gapped via candor.ai.localOnly with local open-weights models like Ollama. Raw schemas, queries, and code remain 100% on your local machine.',
  },
];

export default function SecurityPage() {
  return (
    <div className="bg-slate-50 min-h-screen py-16 animate-fade-in font-sans">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-xs font-bold uppercase tracking-wider text-blue-600">Trust &amp; Compliance</span>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight leading-none mt-2 mb-4">
            Security &amp; Compliance
          </h1>
          <p className="text-slate-600 text-sm sm:text-base leading-relaxed">
            How we protect your data models, database credentials, and AI pipeline execution.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {SECURITY_PILLARS.map((p, idx) => (
            <div key={idx} className="bg-white rounded-2xl p-6 border border-slate-200/50 shadow-sm">
              <div className="text-3xl mb-3">{p.icon}</div>
              <h3 className="font-bold text-slate-900 mb-2 text-md">{p.title}</h3>
              <p className="text-slate-600 text-xs sm:text-sm leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-slate-900 text-slate-300 rounded-3xl p-8 border border-slate-800 shadow-xl">
          <h3 className="text-white font-bold text-lg mb-4">Zero-Data Retention Policy for ML Contexts</h3>
          <p className="text-slate-400 text-xs sm:text-sm leading-relaxed mb-4">
            Candor does not process or transmit your actual database records to external LLM providers. Only the schema definitions (column names, constraints, database types) are used to construct the context for code generation.
          </p>
          <p className="text-slate-400 text-xs sm:text-sm leading-relaxed">
            Your real production database data remains completely within your secure network boundaries during execution.
          </p>
        </div>
      </div>
    </div>
  );
}
